import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react'
import { IFilterParams } from 'ag-grid-community'

interface Props extends IFilterParams {
  children: React.ReactNode
}

const DateFilter = forwardRef<any, Props>((props, ref) => {
  const [dateBefore, setDateBefore] = useState<string | null>(null)
  const [dateAfter, setDateAfter] = useState<string | null>(null)

  // Expose AG Grid Filter Lifecycle callbacks
  useImperativeHandle(ref, () => ({
    isFilterActive() {
      return dateBefore !== null || dateAfter !== null
    },

    doesFilterPass(params: any) {
      const { node } = params
      const value = new Date(props.valueGetter(node))

      const before = dateBefore ? new Date(dateBefore) : null
      const after = dateAfter ? new Date(dateAfter) : null

      if (before && value > before) {
        return false
      }
      if (after && value < after) {
        return false
      }

      return true
    },

    getModel() {
      return this.isFilterActive()
        ? { before: dateBefore, after: dateAfter }
        : null
    },

    setModel(model: any) {
      setDateBefore(model ? model.before : null)
      setDateAfter(model ? model.after : null)
    },
  }))

  useEffect(() => {
    props.filterChangedCallback()
  }, [dateBefore, dateAfter])

  return (
    <div className="p-4 w-[200px]" style={{ padding: 4, width: 200 }}>
      <div>
        <label>After:</label>
        <input
          type="date"
          value={dateAfter ?? ''}
          onChange={(e) => setDateAfter(e.target.value)}
          style={{ width: '100%', padding: '8px', margin: '4px 0' }}
        />
      </div>
      <div>
        <label>Before:</label>
        <input
          type="date"
          value={dateBefore ?? ''}
          onChange={(e) => setDateBefore(e.target.value)}
          style={{ width: '100%', padding: '8px', margin: '4px 0' }}
        />
      </div>
    </div>
  )
})

DateFilter.displayName = 'DateFilter'

export default DateFilter
